import { isDefined } from "@apl-digital/utils";
import { createSelector } from "@reduxjs/toolkit";

import { isLoginEnabled } from "@/api/authSession";
import type { ICartContactInfo } from "@/api/interfaces/cartLayouts";
import { hasData } from "@/store/apiRequestStatusMachine";
import type { RootState } from "@/store/slices";

import { selectUserData } from "./slice";

export const selectUser = (state: RootState) => state.user;

export const selectIsAuthenticated = createSelector(selectUser, (user) => {
  return user.isAuthReady && hasData(user.userData);
});

export const selectShouldShowSignIn = createSelector(selectUser, (user) => {
  return isLoginEnabled() && user.isAuthReady && !hasData(user.userData);
});

export const selectIsAuthLoading = createSelector(selectUser, (user) => {
  return isLoginEnabled() && !user.isAuthReady;
});

export const selectUserContactInfo = createSelector(
  selectUserData,
  (userData): ICartContactInfo => {
    const names = [userData?.FirstName, userData?.LastName].filter((item) =>
      isDefined(item),
    );

    return {
      Name: names.length > 0 ? names.join(" ") : null,
      Email: userData?.Email ?? null,
      Phone: userData?.Phone ?? null,
    };
  },
);
